<!-- @format -->

<sis-loading-screen
  [descriptionKey1]="'PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PROCESSING_PAYMENT_1'"
  [descriptionKey2]="'PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PROCESSING_PAYMENT_2'">
</sis-loading-screen>
